import { address, nameId, shortUIntConst } from "../field-types/index.mjs";
import { Encoding, decode, encode } from "../../../utils/encoder.mjs";
/**
 * @category delegation signature
 */
export let DelegationTag = /*#__PURE__*/function (DelegationTag) {
  DelegationTag[DelegationTag["AensWildcard"] = 1] = "AensWildcard";
  DelegationTag[DelegationTag["AensName"] = 2] = "AensName";
  DelegationTag[DelegationTag["AensPreclaim"] = 3] = "AensPreclaim";
  DelegationTag[DelegationTag["Oracle"] = 4] = "Oracle";
  DelegationTag[DelegationTag["OracleResponse"] = 5] = "OracleResponse";
  return DelegationTag;
}({});
const oracleAddressField = address(Encoding.OracleAddress);
const queryIdField = {
  serialize(value) {
    return oracleAddressField.serialize(encode(decode(value), Encoding.OracleAddress));
  },
  deserialize(value) {
    return encode(decode(oracleAddressField.deserialize(value)), Encoding.OracleQueryId);
  }
};

/**
 * @see {@link https://github.com/aeternity/protocol/blob/8a9d1d1206174627f6aaef86159dc9c643080653/contracts/fate.md#from-ceres-serialized-signature-data}
 */
export const schemas = [{
  tag: shortUIntConst(DelegationTag.AensWildcard),
  version: shortUIntConst(1, true),
  accountAddress: address(Encoding.AccountAddress),
  contractAddress: address(Encoding.ContractAddress)
}, {
  tag: shortUIntConst(DelegationTag.AensName),
  version: shortUIntConst(1, true),
  accountAddress: address(Encoding.AccountAddress),
  nameId,
  contractAddress: address(Encoding.ContractAddress)
}, {
  tag: shortUIntConst(DelegationTag.AensPreclaim),
  version: shortUIntConst(1, true),
  accountAddress: address(Encoding.AccountAddress),
  contractAddress: address(Encoding.ContractAddress)
}, {
  tag: shortUIntConst(DelegationTag.Oracle),
  version: shortUIntConst(1, true),
  accountAddress: address(Encoding.AccountAddress),
  contractAddress: address(Encoding.ContractAddress)
}, {
  tag: shortUIntConst(DelegationTag.OracleResponse),
  version: shortUIntConst(1, true),
  queryId: queryIdField,
  contractAddress: address(Encoding.ContractAddress)
}];
//# sourceMappingURL=schema.mjs.map